package com.gastoncantera.intercom.call

// El navegador muestra el prompt al llamar a getUserMedia; la negación llega como DOMException.
actual suspend fun requireMediaPermission(withVideo: Boolean) {}

internal actual fun classifyPlatformMediaError(e: Throwable): CallError {
    // getUserMedia rechaza con DOMException; nos guiamos por su `.name`.
    val name = (e.asDynamic().name as? String) ?: ""
    return when (name) {
        "NotAllowedError", "SecurityError", "PermissionDeniedError" -> CallError.PermissionDenied
        "NotFoundError", "DevicesNotFoundError", "OverconstrainedError" -> CallError.DeviceNotFound
        else -> CallError.Generic
    }
}
